module.exports = __webpack_public_path__ + "static/media/waves2.6eb15570.png";